import { useMutation } from "react-query";
import { mapValues } from "lodash";
import { useDispatch } from "react-redux";
import { createAuthenticatedRequest, executeRequest } from "./utils";

export const MEDIA_UPLOAD_PATH = "media/upload";

// Execute a POST to upload a file to media/upload endpoint
export async function uploadFile(params) {
  const {
    fileName,
    mode,
    variants,
    containerName = "selfserve-v1",
    mimeType,
    dispatch,
  } = params;

  const queryParams = {
    containerName,
    fileName,
    mimeType,
  };

  if (variants) {
    queryParams.variants = JSON.stringify(variants);
  }

  if (mode === "url") {
    // URL mode: use JSON body with query parameters
    queryParams.url = params.url;

    const requestObject = await createAuthenticatedRequest(
      MEDIA_UPLOAD_PATH,
      dispatch,
      {
        method: "POST",
        brandAuth: true,
        params: queryParams,
      }
    );

    return executeRequest(requestObject);
  }
  // File body mode: use multipart/form-data
  if (mode === "file") {
    const formData = new FormData();
    formData.append("file", params.file);

    const requestObject = await createAuthenticatedRequest(
      MEDIA_UPLOAD_PATH,
      dispatch,
      {
        method: "POST",
        body: formData,
        brandAuth: true,
        params: queryParams,
      },
      true // Skip content-type header for multipart/form-data
    );
    return executeRequest(requestObject);
  }

  throw new Error("Invalid upload mode. Use 'url' or 'file'.");
}

export function useUploadMedia() {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: async params => {
      const mode = "url" in params ? "url" : "file";

      const uploadedUrls = await uploadFile({
        mode,
        dispatch,
        ...params,
      });

      // We do a little remapping here so that our consumers don't have to care
      // about the different upload locations.
      return mapValues(uploadedUrls, url => url.cloudflare);
    },
  });
}
